
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.708 16.167V14.08C2.12 13.615 1.726 12.276 2.5 9.5c.635-2.28 2.146-5.53 4.258-6.408a1.771 1.771 0 113.483.003c2.116.881 3.803 4.123 4.441 6.404.781 2.797.22 4.128 1.61 4.58v2.088h-4.959a2.834 2.834 0 01-5.666 0H.708zm9.917 0h-4.25a2.126 2.126 0 004.25 0zm-9.208-.709h14.166v-.879c-1.46-.65-1.016-2.86-1.583-4.89-.755-2.7-2.517-6.208-5.5-6.21-2.982 0-4.566 3.513-5.318 6.21-.567 2.035-.298 4.238-1.765 4.89v.88zm8.14-12.577l.005-.11a1.063 1.063 0 00-2.125 0l.006.107a4.94 4.94 0 011.053-.107c.384 0 .736.038 1.06.11z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"18","cy":"3","r":"3","fill":"#00B5E7"}})])
          )
        }
      }
    